import { useState } from 'react';
import { formatAnswerSheetQuestionNo, shouldShowQuestionScore } from '../assets/utils/utils';
import { useTestQuestionAnswer } from '../hooks/useTestQuestionAnswer';
import ForwardOnlySheetModal from './modal/forwardOnlySheetModal';

import sheet from '../styles/components/answerSheet.module.scss';

const TestAnswerOptions = ({
    id,
    attemptID,
    options,
    score,
    userAnswered,
    isRank,
    answerResHandler,
    examDataAttempt,
    sheetMode = 'active',
    displayQuNo,
    quizType,
    isCurrentQuestion = false,
}) => {
    const [sheetModal, setSheetModal] = useState(null);
    const showScore = shouldShowQuestionScore(quizType, isRank);

    const {
        activeBtn,
        onOptionClick,
        optionsLocked,
        pendingClearOptionId,
        confirmClearAnswer,
        cancelClearAnswer,
        isClearing,
    } = useTestQuestionAnswer({
        questionId: id,
        attemptID,
        examDataAttempt,
        userAnswered,
        answerResHandler,
        sheetMode,
    });

    const handleAnswerSheetRowClick = () => {
        if (sheetMode === 'past_readonly') {
            setSheetModal('readonly');
            return;
        }
        if (sheetMode === 'past_unanswered') {
            setSheetModal('locked');
            return;
        }
        if (sheetMode === 'future') {
            setSheetModal('future');
        }
    };

    const selectedOption = options?.find((o) => o.id === activeBtn);
    const isSheetModalRow = sheetMode === 'past_readonly' || sheetMode === 'past_unanswered' || sheetMode === 'future';

    return (
        <li key={id} style={{ listStyle: 'none', paddingRight: 0 }}>
            <ForwardOnlySheetModal
                isOpen={sheetModal !== null}
                onClose={() => setSheetModal(null)}
                title={
                    sheetModal === 'readonly'
                        ? `مشاهده پاسخ سوال ${displayQuNo ?? ''}`
                        : sheetModal === 'locked'
                            ? `سوال ${displayQuNo ?? ''}`
                            : sheetModal === 'future'
                                ? `سوال ${displayQuNo ?? ''}`
                                : ''
                }
                text={
                    sheetModal === 'locked'
                        ? 'به‌دلیل حالت «فقط رو به جلو» دیگر امکان ثبت یا ویرایش پاسخ برای این سوال وجود ندارد. در زمان رسیدن به این سوال پاسخی ثبت نشده بود.'
                        : sheetModal === 'future'
                            ? 'هنوز به این سوال نرسیده‌اید. ابتدا با دکمه «سوال بعدی» جلو بروید؛ تا رسیدن نوبت این سوال، پاسخ‌نامه این بخش باز نمی‌شود.'
                            : undefined
                }
            >
                {sheetModal === 'readonly' && selectedOption && (
                    <div style={{ padding: 12, background: '#f9fafb', borderRadius: 8 }}>
                        <p style={{ margin: 0, fontWeight: 600 }}>گزینه انتخاب‌شده</p>
                        <p style={{ margin: '8px 0 0' }}>
                            {selectedOption.option_number}
                            {selectedOption.body ? ` — ${selectedOption.body}` : ''}
                        </p>
                    </div>
                )}
                {sheetModal === 'readonly' && !selectedOption && (
                    <p style={{ color: '#6b7280', margin: 0 }}>پاسخی ثبت نشده است.</p>
                )}
            </ForwardOnlySheetModal>
            <div
                className={`${sheet.sheetRow} ${!showScore ? sheet.sheetRowNoGrade : ''} ${isCurrentQuestion ? sheet.sheetRowCurrent : ''}`}
                onClick={isSheetModalRow ? handleAnswerSheetRowClick : undefined}
                style={isSheetModalRow ? { cursor: 'pointer' } : undefined}
                role={isSheetModalRow ? 'button' : undefined}
            >
                <span className={sheet.questionNo}>{formatAnswerSheetQuestionNo(displayQuNo)}</span>
                <div
                    className={sheet.optionsGrid}
                    style={optionsLocked ? { pointerEvents: sheetMode === 'past_readonly' ? 'none' : 'auto' } : undefined}
                >
                    {options?.map((el) => (
                        <div key={el.id} className={sheet.optionCell}>
                            <div
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onOptionClick(el.id);
                                }}
                                className={`${sheet.optionBtn} ${activeBtn === el.id ? sheet.optionBtnActive : ''}`}
                            >
                                {el.option_number}
                            </div>
                            {pendingClearOptionId === el.id && (
                                <div
                                    className={sheet.clearConfirm}
                                    onClick={(e) => e.stopPropagation()}
                                    role="dialog"
                                    aria-label="تأیید حذف پاسخ"
                                >
                                    <p className={sheet.clearConfirmText}>پاسخ حذف شود؟</p>
                                    <div className={sheet.clearConfirmActions}>
                                        <button
                                            type="button"
                                            className={sheet.clearConfirmYes}
                                            disabled={isClearing}
                                            onClick={confirmClearAnswer}
                                        >
                                            {isClearing ? '...' : 'بله'}
                                        </button>
                                        <button
                                            type="button"
                                            className={sheet.clearConfirmNo}
                                            disabled={isClearing}
                                            onClick={cancelClearAnswer}
                                        >
                                            خیر
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                {showScore && (
                    <div className={sheet.gradeCol}>
                        <span className={sheet.gradeValue}>{score}</span>
                        <span className={sheet.gradeLabel}>بارم</span>
                    </div>
                )}
            </div>
        </li>
    );
};

export default TestAnswerOptions;
